export enum PaymentFrequency {
    ADHOC,
    RECURRING
}